import FBRightsCategory from "../FBRightsCategory";
import stringToHash from "../../data/dataUtils";

class FBRightsCategoryBuilder {
  static buildFBRightsCategory(description, image, subtitle, title) {
    if (description == null || subtitle == null || title == null) {
      return null;
    } else if (
      typeof description !== "string" ||
      typeof subtitle !== "string" ||
      typeof title != "string"
    ) {
      return null;
    }

    const titleHash = stringToHash(title);
    const subtitleHash = stringToHash(subtitle);
    const descriptionHash = stringToHash(description);
    return new FBRightsCategory(
      description,
      image,
      subtitle,
      title,
      descriptionHash,
      titleHash,
      subtitleHash
    );
  }

  static buildJSONToPush(fbRightsCategory) {
    return {
      description: fbRightsCategory.descriptionHash,
      image: "",
      subtitle: fbRightsCategory.subtitleHash,
      title: fbRightsCategory.titleHash,
    };
  }
}

export default FBRightsCategoryBuilder;
